
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1359","height":"127","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47 0H0v126h47V0zm131 126V80H47v46h131z","fill":"#4D4D4D"}}),_c('path',{attrs:{"d":"M29.99 9H17.01C10.377 9 5 14.377 5 21.01v.98C5 28.623 10.377 34 17.01 34h12.98C36.623 34 42 28.623 42 21.99v-.98C42 14.377 36.623 9 29.99 9zm0 84H17.01C10.377 93 5 98.377 5 105.01v.98C5 112.623 10.377 118 17.01 118h12.98c6.633 0 12.01-5.377 12.01-12.01v-.98C42 98.377 36.623 93 29.99 93z","fill":"#fff"}}),_c('path',{attrs:{"d":"M1312 127h47V1h-47v126zm0 0V81h-131v46h131z","fill":"#4D4D4D"}}),_c('path',{attrs:{"d":"M1329.01 34h12.98c6.63 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.38-12.01-12.01-12.01h-12.98c-6.63 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.38 12.01 12.01 12.01zm0 85h12.98c6.63 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.38-12.01-12.01-12.01h-12.98c-6.63 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.38 12.01 12.01 12.01z","fill":"#fff"}})])
          )
        }
      }
    